import { Pipe, PipeTransform } from '@angular/core';
/**
 * This will take a value and format it according to en-US locale. If truncate is set to true, values 1000 and up will
 * be abbreviated
 * @param value
 * @param truncate
 * @return formatted number
 */
@Pipe({
  name: 'formatStat',
  standalone: true,
})
export class FormatStatPipe implements PipeTransform {
  transform(value: number, truncate = false): string {
    return formatStatsNum(value, truncate);
  }
}

export function formatStatsNum(value: number, truncate = false): string {
  if (truncate && value >= 1000) {
    let denominator = 1000;
    let suffix = 'k';

    if (value >= 1000000) {
      denominator = 1000000;
      suffix = 'm';
    }
    const truncated = Math.round((value / denominator) * 10) / 10;
    return truncated % 1 === 0 ? truncated.toFixed(0) + suffix : truncated.toFixed(1) + suffix;
  }
  return value.toLocaleString('en-US');
}
